import Axios from 'axios';
import header from './header';

const API_URL_V3 = process.env.API_URL + '/api/v3/auth/email';

class EmailVerification {
    send() {
        return Axios.post(API_URL_V3 + '/send-otp', null, { headers: header() });
    }
    
    verify(data) {
		return Axios.post(API_URL_V3 + `/verify-otp`, data, { headers: header() });
    }
}

export default new EmailVerification();



// WEBPACK FOOTER //
// ./src/api/auth/EmailVerification.js